__turbopack_context__.v({
  "heroBlock": "ib638W_heroBlock",
});
